import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "./AuthContext";

const StudentProtectedRoute = ({ children, role }) => {
  const { user,loading } = useAuth();

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!user||!user.isAuthenticated) {
    return <Navigate to="/login" />;
  }

  if (role && role!==user.role) {
    return <Navigate to="/unauthorized" />;
  }

  return children;
};

export default StudentProtectedRoute;
